module.exports = __webpack_public_path__ + "media/images/landkit/screenshots/landkit/pages/portfolio-grid-rows-cf6d1cf4339f743dfbfcb11739b27e88.jpg";